<template>
  <div id="user-list">
    <v-snackbar
      v-model="isSnackbarVisible"
      :color="snackbar.color"
      :timeout="snackbar.timeout"
      top
      right
      auto-height
    >
      <v-layout
        align-center
        pr-4
      >
        <v-icon
          class="pr-3"
          dark
          large
        >
          {{ snackbar.icon == 'success' ? icons.mdiCheckBold : icons.mdiCheckBold }}
        </v-icon>

        <v-layout column>
          <div>
            <strong>{{ snackbar.title }}</strong>
          </div>
          <div>{{ snackbar.text }}</div>
        </v-layout>
      </v-layout>
    </v-snackbar>

    <v-dialog
      v-model="isDialogVisible"
      max-width="8 0%"
    >
      <v-card>
        <v-form @submit.prevent="saveData">
          <v-card-title>
            <span class="headline">{{ modalTitle }}</span>
          </v-card-title>
          <v-card-text>
            <v-container>
              <v-row>
                <v-col
                  style="padding: 0;"
                  cols="6"
                >
                  <button
                    class="btn btn-green"
                    @click.prevent="nuevaPartida()"
                  >
                    <v-icon
                      center
                      style="color: white"
                    >
                      {{ icons.mdiPlusCircle }}
                    </v-icon>
                  </button>
                </v-col>

                <v-col
                  style="padding: 0;"
                  cols="6"
                  class="d-flex justify-end align-center"
                >
                  <v-text-field
                    v-model="fila.fecha"
                    type="date"
                    label="Fecha"
                    dense
                    hide-details
                    style="max-width: 200px"
                  />
                </v-col>
              </v-row>
            </v-container>
            <v-container dark>
              <v-simple-table class="tabla-ancha">
                <thead>
                  <tr>
                    <th>CUENTA</th>
                    <th style="width: 240px !important">
                      TITULO
                    </th>
                    <th>INGRESO</th>
                    <th>EGRESO</th>
                    <th>ACCIÓN</th>
                  </tr>
                </thead>
                <tbody
                  v-for="item of fila"
                  :key="item.id"
                >
                  <tr>
                    <td>
                      <v-select
                        v-model="item.codigo_cuenta"
                        item-text="label"
                        item-value="codigo"
                        :items="cuentasFormateadas"
                        dense
                      ></v-select>
                    </td>
                    <td>
                      <v-text-field
                        v-model="item.descripcion"
                        dense
                      ></v-text-field>
                    </td>
                    <td>
                      <v-text-field
                        v-model.number="item.debe"
                        type="number"
                        dense
                        @keyup="calculaDiferencia"
                      ></v-text-field>
                    </td>
                    <td>
                      <v-text-field
                        v-model.number="item.haber"
                        type="number"
                        dense
                        @keyup="calculaDiferencia"
                      ></v-text-field>
                    </td>
                    <td>
                      <v-btn
                        icon
                        color="error"
                        @click="eliminarFila(item)"
                      >
                        <v-icon dark>
                          {{ icons.mdiDeleteOutline }}
                        </v-icon>
                      </v-btn>
                    </td>
                  </tr>
                </tbody>
              </v-simple-table>
            </v-container>
            diferencia:{{ cantidadDiferencia }}
          </v-card-text>

          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn
              color="error"
              outlined
              @click="isDialogVisible = false"
            >
              Cerrar
            </v-btn>
            <v-btn
              :disabled="cantidadDiferencia != 0 || fila.length <= 1 || (totalDebe == 0 && totalHaber == 0)"
              type="submit"
              color="success"
            >
              <!-- @click="isDialogVisible = false" -->
              Guardar
            </v-btn>
          </v-card-actions>
        </v-form>
      </v-card>
    </v-dialog>

    <!-- list filters -->
    <h2 class="m-2">
      Diario
    </h2>
    <v-card>
      <v-btn
        color="info"
        class="m-4"
        @click="showModal(1)"
      >
        <v-icon center>
          {{ icons.mdiPlusCircle }}
        </v-icon>
        &nbsp;Asiento contable
      </v-btn>

      <v-data-table
        :loading="loading"
        :headers="tableColumns"
        :items="items"
      >
        <!-- SLOT PARA SALDO -->
        <template #[`item.fecha`]="{ item }">
          <span class="">{{ $moment.tz(item.fecha, 'America/Costa_Rica').format('DD-MM-YYYY')
          }}</span>
        </template>

        <!-- SLOT PARA INGRESO -->
        <template #[`item.debe`]="{ item }">
          <span class="">{{ 'C$ ' + item.debe }}</span>
        </template>

        <!-- SLOT PARA EGRESO -->
        <template #[`item.haber`]="{ item }">
          <span class="">{{ 'C$ ' + item.haber }}</span>
        </template>

        <template #[`item.acciones`]="{ item }">
          <button
            class="btn btn-green"
            @click="showModal(2, item)"
          >
            <v-icon
              center
              style="color: white"
            >
              {{ icons.mdiPencil }}
            </v-icon>
          </button>
          &nbsp;
          <button
            class="btn btn-red"
            @click="deleteData(item)"
          >
            <v-icon
              center
              style="color: white"
            >
              {{ icons.mdiDeleteOutline }}
            </v-icon>
          </button>
          &nbsp;
        </template>
      </v-data-table>
    </v-card>
  </div>
</template>

<script>
import {
  mdiCheckBold, mdiDeleteOutline, mdiPencil, mdiPlusCircle,
} from '@mdi/js'

import { ref } from '@vue/composition-api'

import Vue from 'vue'

import JsonExcel from 'vue-json-excel'

Vue.component('downloadExcel', JsonExcel)

// sidebar
// import UserListAddNew from './UserListAddNew.vue'
// import userStoreModule from '../userStoreModule'

// import useUsersList from './useUsersList'

export default {
  data() {
    return {
      fila: [
        {
          id: 0,
          codigo_cuenta: null,
          descripcion: '',
          debe: 0,
          haber: 0,
        },
      ],
      cuentas: ['Caja', 'Banco', 'Tarjeta'],
      icons: {
        mdiDeleteOutline, mdiPencil, mdiPlusCircle, mdiCheckBold,
      },
      items: [],
      table: 'diario_contable',
      tableColumns: [
        { text: 'Cuenta', value: 'codigo_cuenta', sortable: true },
        { text: 'Titulo', value: 'nombre_cuenta', sortable: true },

        { text: 'Descripción', value: 'descripcion', sortable: true },
        { text: 'Asiento', value: 'asiento', sortable: true },
        { text: 'Fecha', value: 'fecha', sortable: true },
        { text: 'Debe', value: 'debe', sortable: true },
        { text: 'Haber', value: 'haber', sortable: true },

        // { text: 'Calificación', value: 'calificacion', sortable: true },
        // { text: 'orden Actual', value: 'orden_actual', sortable: true },
        { text: 'Acciones', value: 'acciones', sortable: false },

        // {id:0, name:}
      ],
      loading: false,
      totalItems: 0,
      isDialogVisible: false,
      row: {},
      modalTitle: 'Asiento contable',
      commerceList: [],
      formHasErrors: false,
      errorMessages: '',
      form: ref(null),
      valid: ref(true),
      isSnackbarVisible: false,
      message: '',
      messageColor: 'primary',
      icon: '',
      snackbar: {
        color: 'success',
        icon: 'check_circle',
        mode: 'multi-line',
        title: 'Success',
        text: 'That worked, hoorah.',
        visible: true,
      },
      statusList: [{ nombre: 'Activo' }, { nombre: 'Inactivo' }],
      rolesInAppList: [{ nombre: 'Administrador' }, { nombre: 'Conductor' }, { nombre: 'Empleado' }],
      rolesList: [
        { id: 1, nombre: 'Super Administrador' },
        { id: 2, nombre: 'Administrador' },
        { id: 3, nombre: 'Contador' },
        { id: 4, nombre: 'Atención al cliente y logística' },
        { id: 5, nombre: 'Marketing' },
      ],
      file: null,
      filename1: null,
      json_fields: {
        nombre: 'nombre',
        email: 'email',
        celular: 'celular',
      },
      cantidadDiferencia: 0,
      totalDebe: 0,
      totalHaber: 0,
    }
  },
  computed: {
    cuentasFormateadas() {
      return this.cuentas.map(c => ({
        ...c,
        label: `${c.codigo} - ${c.descripcion}`,
      }))
    },
  },
  async mounted() {
    await this.getData()
    await this.getCuentas()
  },
  methods: {
    calculaDiferencia() {
      this.totalDebe = this.fila.reduce((a, b) => a + b.debe, 0)
      this.totalHaber = this.fila.reduce((a, b) => a + b.haber, 0)
      this.cantidadDiferencia = this.totalDebe != this.totalHaber ? Math.abs(this.totalDebe - this.totalHaber) : 0

      // console.log('debe', debe)
    },
    nuevaPartida() {
      const id = this.fila.length
      console.log('asd', id)
      this.fila.push({
        id,
        codigo_cuenta: null,
        descripcion: '',
        debe: 0,
        haber: 0,
      })
      console.log(this.fila)
    },
    eliminarFila(item) {
      console.log(item)
      this.fila.splice(item.id, 1)
    },
    async cuentaLabel(item) {
      console.log(item)

      return `${item.codigo} - ${item.descripcion}`
    },
    async saveData() {
      try {
        // pendiente la validación del form
        // this.formHasErrors = false
        let fila = [...this.fila]

        // this.$isLoading(true)
        let res
        if (fila.id) {
          // es update
          delete fila.id
          res = await this.$store.dispatch('put', { path: `${this.table}/modify/${this.fila.id}`, data: fila })
        } else {
          fila = fila.map(x => ({
            codigo_cuenta: x.codigo_cuenta,
            descripcion: x.descripcion,
            debe: x.debe,
            haber: x.haber,
            fecha: this.$moment.tz(x.fecha, 'America/Costa_Rica').format('YYYY-MM-DD HH:mm:ss'),
          }))
          res = await this.$store.dispatch('post', { path: `${this.table}/new/`, data: fila })

          // es post
        }
        this.getData()
        this.snackbar = {
          color: 'success',
          icon: 'success',
          mode: 'multi-line',
          title: 'Muy bien!',
          text: 'Registro procesado correctamente!.',
          timeout: '2500',
        }

        this.isDialogVisible = false
        this.isSnackbarVisible = true
        console.log(res)
      } catch (error) {
        console.log(error)
      }
    },
    showModal(type, item) {
      this.row = null
      if (type == 1) {
        this.modalTitle = 'Asiento contable'
        this.row = {}
      } else {
        this.row = item
        this.modalTitle = 'Editar usuario'
      }
      this.isDialogVisible = true
    },
    async getData() {
      try {
        this.loading = true
        const res = await this.$store.dispatch('get', { path: `${this.table}/getAll/` })
        this.loading = false
        if (res.length > 0) {
          this.items = res
          this.totalItems = this.items.length
        }
      } catch (error) {
        this.items = []
        this.loading = false
        console.error('error', error)
      }
    },
    async getCuentas() {
      try {
        this.loading = true
        const res = await this.$store.dispatch('get', { path: 'plan_de_cuentas/getAll/' })
        this.loading = false
        if (res.length > 0) {
          console.log(res)
          this.cuentas = res
        }
      } catch (error) {
        this.cuentas = []
        this.loading = false
        console.error('error', error)
      }
    },
    async deleteData(item) {
      try {
        let txt
        if (confirm('¿Eliminar Registro?')) {
          this.loading = true
          const res = await this.$store.dispatch('delete', { path: `${this.table}/${item.id}` })
          await this.getData()
          this.loading = false
          txt = 'You pressed OK!'
          this.snackbar = {
            color: 'success',
            icon: 'success',
            mode: 'multi-line',
            title: 'Muy bien!',
            text: 'Registro elimiado correctamente!.',
            timeout: '2500',
          }
          this.isSnackbarVisible = true
        } else {
          // txt = 'You pressed Cancel!'
        }
      } catch (error) {
        console.log(error)
      }
    },
  },
}
</script>

<style lang="scss">
@import '@core/preset/preset/apps/user.scss';

.form-control {
  display: block;
  width: 100%;
  height: 34px;
  padding: 6px 12px;
  font-size: 14px;
  line-height: 1.42857143;
  color: #555;
  background-color: #fff;
  background-image: none;
  border: 1px solid #ccc;
}

.btn-green {
  color: rgb(255, 255, 255) !important;
  background-color: #20b11b !important;
  border-color: #20b11b !important;
}

.btn-blue {
  color: #fff !important;
  background-color: #007bff !important;
  border-color: #007bff !important;
}

.btn-red {
  color: #fff !important;
  background-color: #ff0037 !important;
  border-color: #ff0037 !important;
}

.btn {
  display: inline-block;
  font-weight: 400;
  text-align: center;
  white-space: nowrap;
  vertical-align: middle;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
  border: 1px solid transparent;
  padding: 0.375rem 0.75rem;
  font-size: 1rem;
  line-height: 1.5;
  border-radius: 0.25rem;
  transition: color 0.15s ease-in-out, background-color 0.15s ease-in-out, border-color 0.15s ease-in-out,
    box-shadow 0.15s ease-in-out;
}

.vv-btn {
  display: inline-block;
  font-weight: 400;
  text-align: center;
  white-space: nowrap;
  vertical-align: middle;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
  border: 1px solid transparent;
  padding: 0.375rem 0.75rem;
  font-size: 1rem;
  line-height: 1.5;
  border-radius: 0.25rem;
  transition: color 0.15s ease-in-out, background-color 0.15s ease-in-out, border-color 0.15s ease-in-out,
    box-shadow 0.15s ease-in-out;
  background-color: rgb(48, 146, 48);
  color: white;
}

.value-box {
  display: inline-block;
  padding: 4px 10px;
  border-radius: 8px;
  font-weight: bold;
  color: white;
}

.green-bg {
  background-color: #4caf50;
}

.red-bg {
  background-color: #f44336;
}

.styled-date-input {
  padding: 8px 12px;
  border: 1px solid #ccc;
  border-radius: 6px;
  font-size: 14px;
  background-color: transparent;
  color: #333;
  outline: none;
  transition: border-color 0.3s ease;
}

.styled-date-input:focus {
  border-color: #ffffff;
  /* verde */
}

.tabla-ancha table {
  table-layout: fixed;
  width: 100%;
}

.tabla-ancha th:nth-child(1),
.tabla-ancha td:nth-child(1) {
  width: 150px;
}

.tabla-ancha th:nth-child(2),
.tabla-ancha td:nth-child(2) {
  width: 200px;
}

.tabla-ancha th:nth-child(3),
.tabla-ancha td:nth-child(3),
.tabla-ancha th:nth-child(4),
.tabla-ancha td:nth-child(4) {
  width: 100px;
}

.tabla-ancha th:nth-child(5),
.tabla-ancha td:nth-child(5) {
  width: 80px;
}
</style>
